export const isFacultyLed = (sessionTypeArr) => {
  return Array.isArray(sessionTypeArr) ? !!sessionTypeArr.find(sessionType => sessionType.name === "Faculty Led") : false;
};
